import { paths } from './paths';

/**
 * "Create order" isn't a single uniform route across roles: owner/manager
 * skip straight to the add-order form, while admin/client go through their
 * own intermediary flow (`OrderMiddleware` / `OrderAddAsStockOwner`) at
 * `/orders/new`. Anything else falls back to `/orders/new` too.
 *
 * Shared by `WelcomeQuickActions` (static "Create order" shortcut) and
 * `usePresentationActionExecutor` (AI `order-form` deep link) so both entry
 * points into the canonical order form agree on the same per-role path.
 */
const CREATE_ORDER_PATH_BY_ROLE: Readonly<Record<string, string>> = {
  owner: paths.orderAddAsOwner,
  manager: paths.orderAddAsOwner,
};

export const resolveCreateOrderPath = (
  userRole: string | null | undefined
): string => CREATE_ORDER_PATH_BY_ROLE[userRole ?? ''] ?? paths.orderNew;
